export default {
  title: 'Der Import läuft gerade... 🙂',
  description: 'Du bekommst eine Slack-Benachrichtigung, sobald der Import abgeschlossen ist.',
  buttons: {
    open_followers_list: 'Followerliste öffnen',
  },
};
